import uniqueId from 'lodash/uniqueId';
import { bytesToSize } from '../helpers/filename';

export const THUMB_MAX_DIMENSION = 512;

export function getThumbnailDimensions(width, height) {
    const scale = Math.min(1, THUMB_MAX_DIMENSION / Math.max(width, height));

    return {
        width: Math.max(1, Math.round(width * scale)),
        height: Math.max(1, Math.round(height * scale)),
    };
}

export function loadImageFiles(files) {
    return Promise.all(files.map(file => {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                const dimensions = getThumbnailDimensions(image.width, image.height);
                canvas.width = dimensions.width;
                canvas.height = dimensions.height;
                ctx.imageSmoothingEnabled = true;
                ctx.imageSmoothingQuality = 'high';
                ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
                const thumb = new Image();
                thumb.onload = () => resolve({
                    id: uniqueId(),
                    type: file.type,
                    name: file.name,
                    fullSize: image,
                    thumb,
                    size: {
                        width: image.width,
                        height: image.height,
                    },
                    fileSize: {
                        bytes: file.size,
                        readable: bytesToSize(file.size),
                    },
                });
                thumb.onerror = () => reject(new Error('Failed to create thumbnail'));
                thumb.src = canvas.toDataURL();
            };
            image.onerror = () => reject(new Error('Failed to load image'));
            image.src = URL.createObjectURL(file);
        });
    }));
}
